import { Checkbox } from "@mui/material";

const RadioButton = ({ label, value, onChange, disabled, style}) => {
  return (
    <label>
      <Checkbox type="checkbox" checked={value} onChange={onChange} disabled={disabled} style={{...style}} />
      {label}
    </label>
  );
};


export default RadioButton;